import {getBookingHost} from "../util/HostUtils";
import React from "react";
import {useKensuAuth} from "../util/authwrapper/AuthWrapper";
import {ActionButton} from "../util/UI/ActionButton";

export const LoginGate = () => {

  const {loginWithRedirect} = useKensuAuth();

  const auth0Login = () => {
    loginWithRedirect({
      appState: {
        returnTo: window.location.pathname
      },
    });
  }

  return <div className={'SplashPageContainer'}>
    <div className={'SplashPageContent'} style={{textAlign: 'center'}}>
      <h2>Kensu for Business</h2>
      <div style={{marginBottom: 20}}>
        Create an account or log in to manage your business.
      </div>
      <div>
        <ActionButton onClick={auth0Login}>Continue</ActionButton>
      </div>
      <div className={'BrownText'} style={{margin: 20}}>
        Are you looking to <a href={getBookingHost()}>book an appointment</a>?
      </div>
    </div>
  </div>
}